export default defineNuxtPlugin((app) => {
	const getCookieValue = (name) => document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)")?.pop() || "";
	addRouteMiddleware("auth", () => {
		const oneTimeTokenPending = useState("oneTimeTokenPending", () => false);
		const { locale } = app.$i18n;
		if (oneTimeTokenPending.value) {
			return;
		}
		if (getCookieValue("token") == "") {
			// return navigateTo(`/${locale.value}/login`)
			window.location.assign(`/${locale.value}/login`);
		}
	});
});
